<div id="blog-app" class="my-1">
    <search-box
        :searchQuery="searchQuery"
        @update:searchQuery="searchQuery = $event"
    />

    <filter-header
        :categoriesFacets="categoriesFacets"
        :selectedCategory="selectedCategory"
        @update:selectedCategory="selectedCategory = $event"
    />

    <filter-popup
        :categoriesFacets="categoriesFacets"
        :selectedCategory="selectedCategory"
        @update:selectedCategory="selectedCategory = $event"
        :selectedRegion="selectedRegion"
        :regionsFacets="regionsFacets"
        @update:selectedRegion="selectedRegion = $event"
        :taxonomyFilters="taxonomyFilters"
        :selectedTerms="selectedTerms"
        @update:taxonomyFilters="updateTaxonomyFilters"
        :clearFilters="clearFilters"
        :totalResults="totalResults"
    />

    <results-count
        v-if="!isLoading"
        :results="results"
        :totalResults="totalResults"
        :searchQuery="searchQuery"
        :selectedCategory="selectedCategory"
        :selectedRegion="selectedRegion"
        :selectedTerms="selectedTerms"
        :clearFilters="clearFilters"
        :layoutType="layoutType"
    />

    <grid-view
        :results="results"
        :isLoading="isLoading"
        :categoriesFacets="categoriesFacets"
        @update:selectedCategory="selectedCategory = $event"
    />

    <pagination
        v-if="!isLoading"
        :currentPage="currentPage"
        :totalPages="totalPages"
        @update:currentPage="currentPage = $event"
    />
</div>
